import {getInstance as getDataSources} from 'datasources';
import { attemptLogout } from 'store/actions/modals/login';
import {getInstance as getStore} from 'store/store';
import ErrorCodes from 'errorcodes';
import {setPlayer} from 'store/actions/widgets/player';

import _ from 'lodash';

/**
 * Created by rickborst on 27/07/2017.
 */

const ActionTypes = {
        SET_HEADER_BACKGROUND_COLOR: 'SET_BACKGROUND_COLOR',
        SET_LAST_HEADER_DATA: 'SET_LAST_HEADER_DATA',
        SET_CHANNEL_TOP_MENU: 'SET_CHANNEL_TOP_MENU'
    },
    BackgroundColors = {
        DEFAULT: 'DEFAULT',
        BLACK: 'BLACK'
    };

/**
 * Sets the headers background color to a persistent value.
 *
 * @param {string} color - Background color.
 * @returns {Object} Action object.
 */
function setBackgroundColor (color) {

    return {
        type: ActionTypes.SET_HEADER_BACKGROUND_COLOR,
        color
    };
}

/**
 * Creates and returns last header data.
 *
 * @param {Asset} lastHeaderData - Last header data before redirection.
 * @returns {Object} Last header data.
 */
function saveLastHeaderData (lastHeaderData) {
    return {
        type: ActionTypes.SET_LAST_HEADER_DATA,
        lastHeaderData
    };
}

/**
 * Saves channel top menu data.
 *
 * @param {Object} channelTopMenu - Channel top menu data.
 * @returns {Object} Action object.
 */
function saveChannelTopMenu (channelTopMenu) {
    return {
        type: ActionTypes.SET_CHANNEL_TOP_MENU,
        channelTopMenu
    };
}

/**
 * ClosePlayer.
 */
function closePlayer () {
    let store = getStore();

    store.dispatch(setPlayer({
        on: false,
        asset: {}
    }));
}

/**
 * Loads header top menu  = same data like for onnow rail.
 *
 * @param {number} onNowRailId - On now rail ID.
 * @returns {Object} Action object.
 */
function getChannelTopMenu (onNowRailId) {

    return (dispatch, getState) => {  // eslint-disable-line no-unused-vars

        let requestParams = {
                rail: {
                    id: onNowRailId
                }
            },
            dataSources = getDataSources();

        return dataSources.loadRailAssets(requestParams)
            .then((data) => {

                dispatch(saveChannelTopMenu(data));

                return Promise.resolve(data);
            }).catch((error) => {

                // logout user when ks expires
                let errorCode = _.get(error, ['result', 'error', 'code']);

                if (errorCode === ErrorCodes.SESSION_EXPIRED) {
                    closePlayer();
                    dispatch(attemptLogout(true));
                }

                return Promise.reject(error);
            });

        };
}

export {
    ActionTypes,
    BackgroundColors,
    setBackgroundColor,
    saveLastHeaderData,
    getChannelTopMenu
};


// WEBPACK FOOTER //
// ./src/js/store/actions/widgets/header.js